import { useState } from 'react';
import { cn } from '@/lib/utils';

const REASONS = [
  'Spam or scam',
  'Harassment or hate',
  'Explicit content',
  'Misinformation',
  'Off-topic',
  'Other',
];

/** `.cv-report-root` modal — reason buttons + optional note. Submit inserts into
 *  the Supabase `reports` table (handled by the parent). */
export function ReportModal({
  onClose,
  onSubmit,
}: {
  onClose: () => void;
  onSubmit: (reason: string, note: string) => void;
}) {
  const [reason, setReason] = useState<string | null>(null);
  const [note, setNote] = useState('');

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-[6px]" onClick={onClose} />
      <div className="relative w-[min(440px,calc(100vw-32px))] rounded-[22px] border border-white/[0.06] bg-[rgba(10,10,13,0.62)] p-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.07),0_24px_60px_rgba(0,0,0,0.45)] backdrop-blur-[40px] backdrop-saturate-[1.4]">
        <div className="text-[10px] font-extrabold uppercase tracking-[1.4px] text-white/50">Report post</div>
        <h3 className="mb-4 mt-1.5 text-lg font-extrabold text-white">What’s wrong with this?</h3>
        <div className="mb-3.5 flex flex-col gap-2">
          {REASONS.map((r) => (
            <button
              key={r}
              className={cn(
                'flex cursor-pointer items-center gap-2.5 rounded-[10px] border border-white/[0.06] bg-transparent px-3 py-2.5 text-left text-[13px] font-medium text-white/[0.78] transition-[background,border-color,color] duration-150',
                reason === r && 'border-white/25 bg-white/[0.07] text-white',
              )}
              onClick={() => setReason(r)}
            >
              {r}
            </button>
          ))}
        </div>
        <textarea
          className="mb-4 min-h-[72px] w-full resize-y rounded-[10px] border border-white/[0.08] bg-white/[0.03] px-3 py-2.5 text-[13px] text-white outline-none"
          placeholder="Add a note (optional)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
        <div className="flex justify-end gap-2">
          <button
            className="cursor-pointer rounded-pill border border-white/[0.14] bg-transparent px-4 py-[9px] text-[13px] font-bold text-white"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="cursor-pointer rounded-pill border border-white bg-white px-4 py-[9px] text-[13px] font-bold text-[#0a0a0d] disabled:cursor-default disabled:opacity-40"
            disabled={!reason}
            onClick={() => reason && onSubmit(reason, note)}
          >
            Submit report
          </button>
        </div>
      </div>
    </div>
  );
}
